import { request } from "./request";

const BASE_URL = "/api/tasks";

export default {
  async toggleState(taskId, itemId, done) {
    return await request({
      url: `${BASE_URL}/${taskId}/checklist/${itemId}`,
      method: "PUT",
      data: { done },
    });
  },
};
